import { classNames, money } from "../../utils/helpers";

export default function HeatTile({ name, value, max, onClick, active }) {
  const intensity = max > 0 ? value / max : 0;
  // purely tailwind: keep simple 4 steps
  const level =
    intensity >= 0.75 ? "bg-blue-600 text-white" :
    intensity >= 0.5 ? "bg-blue-400 text-white" :
    intensity >= 0.25 ? "bg-blue-200 text-blue-900" :
    "bg-blue-50 text-blue-700";

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "flex flex-col gap-1 rounded-2xl border border-blue-100 p-3 text-left transition hover:shadow-sm",
        level,
        active ? "ring-2 ring-blue-300" : ""
      )}
      title={`${name} • ${money(value)}`}
    >
      <p className="text-xs font-semibold opacity-90">{name}</p>
      <p className="text-sm font-semibold">{money(value)}</p>
    </button>
  );
}